/** @typedef {'signup'|'match'|'cards'|'other'} ExternalChargeTypeGroup */

/** @type {{ id: ExternalChargeTypeGroup, labelId: string }[]} */
export const EXTERNAL_CHARGE_TYPE_GROUPS = [
  { id: "signup", labelId: "gestion.financials.chargeTypeGroup.signup" },
  { id: "match", labelId: "gestion.financials.chargeTypeGroup.match" },
  { id: "cards", labelId: "gestion.financials.chargeTypeGroup.cards" },
  { id: "other", labelId: "gestion.financials.chargeTypeGroup.other" },
];

/** @type {{ value: string, group: ExternalChargeTypeGroup, labelId: string }[]} */
export const EXTERNAL_CHARGE_TYPES = [
  { value: "tournament-entry-fee", group: "signup", labelId: "gestion.financials.chargeType.tournamentEntryFee" },
  { value: "match-fee", group: "match", labelId: "gestion.financials.chargeType.matchFee" },
  { value: "yellow-card-fee", group: "cards", labelId: "gestion.financials.chargeType.yellowCardFee" },
  { value: "red-card-fee", group: "cards", labelId: "gestion.financials.chargeType.redCardFee" },
  {
    value: "double-yellow-card-fee",
    group: "cards",
    labelId: "gestion.financials.chargeType.doubleYellowCardFee",
  },
  { value: "sanction-fee", group: "cards", labelId: "gestion.financials.chargeType.sanctionFee" },
  { value: "protest-fee", group: "other", labelId: "gestion.financials.chargeType.protestFee" },
  { value: "social-club-fee", group: "other", labelId: "gestion.financials.chargeType.socialClubFee" },
  { value: "custom-fee", group: "other", labelId: "gestion.financials.chargeType.customFee" },
];

export const DEFAULT_EXTERNAL_CHARGE_TYPE = "tournament-entry-fee";

export const chargeTypeLabelId = (value) =>
  EXTERNAL_CHARGE_TYPES.find((item) => item.value === value)?.labelId ?? value;

export const chargeTypesByGroup = () =>
  EXTERNAL_CHARGE_TYPE_GROUPS.map((group) => ({
    ...group,
    types: EXTERNAL_CHARGE_TYPES.filter((item) => item.group === group.id),
  })).filter((group) => group.types.length > 0);

export const isKnownChargeType = (value) => EXTERNAL_CHARGE_TYPES.some((item) => item.value === value);
